export default {
  login: 'Souraevshing',
  id: 50770504,
  node_id: 'MDQ6VXNlcjUwNzcwNTA0',
  avatar_url: 'https://avatars.githubusercontent.com/u/50770504?v=4',
  gravatar_id: '',
  url: 'https://api.github.com/users/Souraevshing',
  html_url: 'https://github.com/Souraevshing',
  followers_url: 'https://api.github.com/users/Souraevshing/followers',
  following_url:
    'https://api.github.com/users/Souraevshing/following{/other_user}',
  gists_url: 'https://api.github.com/users/Souraevshing/gists{/gist_id}',
  starred_url:
    'https://api.github.com/users/Souraevshing/starred{/owner}{/repo}',
  subscriptions_url: 'https://api.github.com/users/Souraevshing/subscriptions',
  organizations_url: 'https://api.github.com/users/Souraevshing/orgs',
  repos_url: 'https://api.github.com/users/Souraevshing/repos',
  events_url: 'https://api.github.com/users/Souraevshing/events{/privacy}',
  received_events_url:
    'https://api.github.com/users/Souraevshing/received_events',
  type: 'User',
  site_admin: false,
  name: 'sauravShing',
  company: null,
  blog: '',
  location: null,
  email: 'isauravshing@gmail.com',
  hireable: true,
  bio: 'Techy',
  twitter_username: 'souraevshing',
  public_repos: 8,
  public_gists: 0,
  followers: 0,
  following: 0,
  created_at: '2019-05-18T11:50:50Z',
  updated_at: '2021-08-04T15:11:47Z',
}
